import { computed } from 'vue'
import type { IbexaBaseItemFields } from '@/types/Ibexa'
import IbexaContentTypeIdentifier from '@/enums/IbexaContentTypeIdentifier'

export function removeXmlTags(xml: string): string {
  const pattern = /^<\?xml [^>]*\?>|<\?xml version="1.0"\?>/g
  return xml?.replaceAll(pattern, '')
}

const removeHtmlTags = (str: string): string => {
  return str.replace(/<\/?[^>]+(>|$)/g, '')
}

export const removeSoftHyphen = (string: string): string => string.replaceAll(/&shy;/g, '')

export function stripStringFromEndToSlash(word: string): string {
  const parts = word.split('/')

  // Extract the last part up to the first "/"
  return parts[parts.length - 1].split(' ')[0]
}

export const snakeToCamelCase = (str: string): string =>
  str.toLowerCase().replace(/([-_][a-z])/g, group =>
    group
      .toUpperCase()
      .replace('-', '')
      .replace('_', '')
  )

export const createSlug = (element: IbexaBaseItemFields): string => {
  const cleanTitle = removeHtmlTags(element.title)
  const noSpaceString = cleanTitle.replaceAll(' ', '-')
  return `${removeSoftHyphen(noSpaceString)}_id:${element.contentId}`
}

export const parseSlug = (slug: string): string => {
  return slug.split('_id:')[0].replaceAll('-', ' ')
}

// Used to format the program label for a subject ("SF VG1" or "YK VG2" etc.)
export const formatProgramLabel = (program: string, level: string) => {
  let shortProgramName = undefined

  if (program === 'Studieforberedende') {
    shortProgramName = 'SF'
  }

  if (program === 'Yrkesfaglig') {
    shortProgramName = 'YK'
  }

  if (!shortProgramName || !level) {
    return undefined
  }

  return `${shortProgramName} ${level}`.toUpperCase()
}

export const createQueryKey = (key: string, id: number | string) => computed(() => [key, id])

export const depthFilter = (parentItem: IbexaBaseItemFields | undefined, childItem: IbexaBaseItemFields, maxDepth: number) => {
  if (!parentItem) return false
  return childItem.depth - parentItem.depth <= maxDepth
}

export const generateRandomString = (length = 10) => {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  return [...Array(length)].map(() => characters[Math.floor(Math.random() * characters.length)]).join('')
}

export const isContentType = (contentObject: IbexaBaseItemFields, contentType: IbexaContentTypeIdentifier) => contentObject.contentTypeIdentifier === contentType

export const randomIntValue = (min: number, max: number) => {
  return Math.floor(Math.random() * (max - min + 1) + min)
}